<template>
    <div class="friend">
        <div class=" swiper-container1  backgroundfff">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend01.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend02.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend03.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend04.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend05.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend06.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend07.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend08.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend09.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend10.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend11.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend12.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend13.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend14.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend15.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend16.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend17.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend18.png">
                </div>
                <div class="swiper-slide">
                    <img src="@/assets/friend/friend19.png">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Swiper from "swiper"
    export default {
        data() {
            return {

            }
        },
        mounted() {
            this.myswiper1()
        },
        methods: {
            myswiper1: function () {
                var swiper1 = new Swiper('.swiper-container1', {
                    loop: true,
                    autoplay: {
                        disableOnInteraction: false,
                    },
                    slidesPerView: 7,
                    spaceBetween: 44,
                    centeredSlides: true,

                });
            }
        },
    }
</script>
<style lang="scss" scoped>
    .friend {
        overflow: hidden;
        padding: 64px 0;
        background: linear-gradient(279.38deg, #F5F2F0 -1.72%, #F2F6F7 101.07%);

        .swiper-slide {
            img {
                width: 100%;
            }
        }
    }
</style>